import { ComponentProps } from 'react';
import { VariantProps } from 'tailwind-variants';
import { Icon, iIconProps } from '../Icon';
import { chip, leftIconClasses, rightIconClasses } from './variants';

type ChipProps = ComponentProps<'span'> &
  VariantProps<typeof chip> & {
    color?: string;
    variant?: string;
    active?: boolean;
    size?: string;
    radius?: string;
    leftIcon?: iIconProps;
    rightIcon?: iIconProps;
    className?: string;
    clamp?: boolean;
  };

function Chip({
  variant = 'filled',
  size = 'md',
  radius = 'sm',
  color,
  active = false,
  leftIcon,
  rightIcon,
  className,
  children,
  clamp = false,
  ...props
}: ChipProps) {
  const hover = props.onClick ? ' hover:cursor-pointer' : '';
  
  return (
    <span
      {...props}
      className={chip({ active, color, variant, size, radius, className: className }) + hover}
    >
      {leftIcon && (
        <Icon
          Icon={leftIcon.Icon}
          type={leftIcon.type}
          className={leftIconClasses({
            variant,
            size,
            className: leftIcon.className,
          })}
          onClick={leftIcon.onClick}
        />
      )}
      <span className={`m-auto flex-1 whitespace-nowrap text-center leading-none ${clamp ? 'max-w-20 truncate' : ''}`}>
        {children}
      </span>
      {rightIcon && (
        <Icon
          Icon={rightIcon.Icon}
          type={rightIcon.type}
          className={rightIconClasses({
            variant,
            size,
            className: rightIcon.className,
          })}
          onClick={rightIcon.onClick}
        />
      )}
    </span>
  );
}

export { Chip };
export type { ChipProps };
